import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'split-list-badge',
  templateUrl: './split-list-badge.component.html',
  styleUrls: ['./split-list-badge.component.scss']
})
export class SplitListBadgeComponent implements OnChanges {
  @Input() public key: string = '';
  @Input() public list: Array<any> = [];
  @Input() public maxWidth: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['key']) {
      if(this.key) {
        this.list = this.list.map(item => {
        item[this.key] = getValue(item, this.key);
        return item;
      });
      }
    }
  }
}

function getValue(obj: any, keyPath: string = "") {
  return keyPath.split('.').reduce((acc, key) => acc && acc[key], obj);
}

